import { createContext, useContext } from 'react'

import type { PropsWithChildren, ReactElement } from 'react'
import type { IUserMe } from '~/types/user'

const AuthorizationsContext = createContext<string[]>([])

interface Props {
  user: IUserMe
}

const AuthorizationsProvider = ({ children, user }: PropsWithChildren<Props>): ReactElement | null => {
  return <AuthorizationsContext.Provider value={user.authorizations}>{children}</AuthorizationsContext.Provider>
}

export const useAuthorizations = (): string[] => {
  return useContext(AuthorizationsContext)
}

export const useIsUserAuthorized = (authorizations: string[]): boolean => {
  const userAuthorizations = useContext(AuthorizationsContext)
  return authorizations.every((el) => userAuthorizations.includes(el))
}

export default AuthorizationsProvider
